 import classes from './ErrorContent.module.css'
 function ErrorContent({ title, children }) {
    return (
        <div className={classes.content}>
            <h1>{title}</h1>
            {children}
        </div>
    );
}

export default ErrorContent;